import { render, staticRenderFns } from "./BatteryPointer.vue?vue&type=template&id=c93640b4&scoped=true&"
import script from "./BatteryPointer.vue?vue&type=script&lang=js&"
export * from "./BatteryPointer.vue?vue&type=script&lang=js&"
import style0 from "./BatteryPointer.vue?vue&type=style&index=0&id=c93640b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93640b4",
  null
  
)

export default component.exports